import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  numberToChar93r9buh19yek as numberToChar,
  toByte4i43936u611k as toByte,
  numberToInt1ygmcfwhs2fkq as numberToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  toString22rbkbhdb5cl2 as toString,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  Char__plus_impl_qi7pgjft9ii3h59tnw as Char__plus_impl_qi7pgj,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  AssertionError3yq7q0knw9m5 as AssertionError,
  NumberFormatException3bgsm2s9o4t55 as NumberFormatException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  numberToLong2pakxeg38estk as numberToLong,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  negate13xrbakfwasjy as negate,
  multiply2k9eolhnz1bjv as multiply,
  subtract2orl8z9upxd9l as subtract,
  toNumber2e2hj9zugjwi2 as toNumber,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  copyOf3rutauicler23 as copyOf,
  copyOf2ng0t8oizk6it as copyOf_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { EOFException34hypof9gkxss as EOFException } from '../../../../../../okio-parent-okio/okio/NonJvmPlatform.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  JsonEncodingException1gbe1fu68vssf as JsonEncodingException,
  JsonDataException2rdtm884tky1l as JsonDataException,
} from '../../exception/Exceptions.mjs';
import { Companion_getInstance2g1g1maz1t653 as Companion_getInstance } from '../../../../../../okio-parent-okio/okio/ByteString.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Token_BEGIN_OBJECT_getInstance3tyutof7o1m8y as Token_BEGIN_OBJECT_getInstance,
  Token_END_OBJECT_getInstance2ogiuwolu9z45 as Token_END_OBJECT_getInstance,
  Token_BEGIN_ARRAY_getInstance177lhv8laq3oc as Token_BEGIN_ARRAY_getInstance,
  Token_END_ARRAY_getInstance2ak1vc2v5jwfi as Token_END_ARRAY_getInstance,
  Token_NAME_getInstance4fu13sk4ahsk as Token_NAME_getInstance,
  Token_BOOLEAN_getInstance1wgqdwqznzt13 as Token_BOOLEAN_getInstance,
  Token_NULL_getInstancepc9ujj0oty64 as Token_NULL_getInstance,
  Token_STRING_getInstance470sjyvft5q9 as Token_STRING_getInstance,
  Token_LONG_getInstance2zqadaqyxtu82 as Token_LONG_getInstance,
  Token_NUMBER_getInstancevca4d508ugjn as Token_NUMBER_getInstance,
  Token_END_DOCUMENT_getInstance2id197vicmeuj as Token_END_DOCUMENT_getInstance,
} from './JsonReader.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toDouble1kn912gjoizjp as toDouble,
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  isNaNymqb93xtq8w8 as isNaN_0,
  isInfinite12nl8hpz1hbp2 as isInfinite,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { JsonNumber2j5ykr5cbjkre as JsonNumber } from './JsonNumber.mjs';
import { JsonScope_instance394helby6dhwe as JsonScope_instance } from './internal/JsonScope.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function doPeek($this) {
  var peekStack = $this.o4a_1[$this.p4a_1 - 1 | 0];
  switch (peekStack) {
    case 1:
      $this.o4a_1[$this.p4a_1 - 1 | 0] = 2;
      break;
    case 2:
      var c = nextNonWhitespace($this, true);
      $this.j4a_1.w3x();
      var tmp1_subject = numberToChar(c);
      if (tmp1_subject === _Char___init__impl__6a9atx(93)) {
        // Inline function 'kotlin.also' call
        $this.k4a_1 = 4;
        return 4;
      } else if (tmp1_subject !== _Char___init__impl__6a9atx(44)) {
        throwSyntaxError($this, 'Unterminated array');
      }

      break;
    case 3:
    case 5:
      $this.o4a_1[$this.p4a_1 - 1 | 0] = 4;
      if (peekStack === 5) {
        var c_0 = nextNonWhitespace($this, true);
        $this.j4a_1.w3x();
        var tmp2_subject = numberToChar(c_0);
        if (tmp2_subject === _Char___init__impl__6a9atx(125)) {
          // Inline function 'kotlin.also' call
          $this.k4a_1 = 2;
          return 2;
        } else if (tmp2_subject !== _Char___init__impl__6a9atx(44)) {
          throwSyntaxError($this, 'Unterminated object');
        }
      }

      var c_1 = nextNonWhitespace($this, true);
      var tmp3_subject = numberToChar(c_1);
      var tmp;
      if (tmp3_subject === _Char___init__impl__6a9atx(34)) {
        $this.j4a_1.w3x();
        // Inline function 'kotlin.also' call
        $this.k4a_1 = 13;
        tmp = 13;
      } else if (tmp3_subject === _Char___init__impl__6a9atx(125)) {
        var tmp_0;
        if (!(peekStack === 5)) {
          $this.j4a_1.w3x();
          // Inline function 'kotlin.also' call
          $this.k4a_1 = 2;
          tmp_0 = 2;
        } else {
          throwSyntaxError($this, 'Expected name');
        }
        tmp = tmp_0;
      } else {
        throwSyntaxError($this, 'Unexpected character: ' + toString(numberToChar(c_1)));
      }

      return tmp;
    case 4:
      $this.o4a_1[$this.p4a_1 - 1 | 0] = 5;
      var c_2 = nextNonWhitespace($this, true);
      $this.j4a_1.w3x();
      if (!(numberToChar(c_2) === _Char___init__impl__6a9atx(58))) {
        throwSyntaxError($this, "Expected ':'");
      }

      break;
    case 6:
      $this.o4a_1[$this.p4a_1 - 1 | 0] = 7;
      break;
    case 7:
      var c_3 = nextNonWhitespace($this, false);
      if (c_3 === -1) {
        // Inline function 'kotlin.also' call
        $this.k4a_1 = 17;
        return 17;
      } else {
        throwSyntaxError($this, 'Malformed JSON');
      }

      break;
    default:
      // Inline function 'kotlin.check' call

      if (!!(peekStack === 8)) {
        var message = 'JsonReader is closed';
        throw IllegalStateException().o(toString_0(message));
      }

      break;
  }
  var c_4 = nextNonWhitespace($this, true);
  var tmp4_subject = numberToChar(c_4);
  if (tmp4_subject === _Char___init__impl__6a9atx(93)) {
    if (peekStack === 1) {
      $this.j4a_1.w3x();
      // Inline function 'kotlin.also' call
      $this.k4a_1 = 4;
      return 4;
    } else {
      throwSyntaxError($this, 'Unexpected value');
    }
  } else if (tmp4_subject === _Char___init__impl__6a9atx(59) || (tmp4_subject === _Char___init__impl__6a9atx(44) || tmp4_subject === _Char___init__impl__6a9atx(39))) {
    throwSyntaxError($this, 'Unexpected value');
  } else if (tmp4_subject === _Char___init__impl__6a9atx(34)) {
    $this.j4a_1.w3x();
    // Inline function 'kotlin.also' call
    $this.k4a_1 = 9;
    return 9;
  } else if (tmp4_subject === _Char___init__impl__6a9atx(91)) {
    $this.j4a_1.w3x();
    // Inline function 'kotlin.also' call
    $this.k4a_1 = 3;
    return 3;
  } else if (tmp4_subject === _Char___init__impl__6a9atx(123)) {
    $this.j4a_1.w3x();
    // Inline function 'kotlin.also' call
    $this.k4a_1 = 1;
    return 1;
  }
  var result = peekKeyword($this);
  if (!(result === 0)) {
    return result;
  }
  result = peekNumber($this);
  if (!(result === 0)) {
    return result;
  }
  if (!isLiteral($this, numberToChar($this.j4a_1.j3w(0n)))) {
    throwSyntaxError($this, 'Expected value');
  }
  throwSyntaxError($this, 'Malformed JSON');
}
function peekKeyword($this) {
  var keyword;
  var keywordUpper;
  var peeking;
  var tmp0_subject = $this.j4a_1.j3w(0n);
  var tmp;
  var tmp_0 = tmp0_subject;
  // Inline function 'kotlin.code' call
  var this_0 = _Char___init__impl__6a9atx(116);
  var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
  if (tmp_0 === toByte(tmp$ret$0)) {
    tmp = true;
  } else {
    var tmp_1 = tmp0_subject;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(84);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = tmp_1 === toByte(tmp$ret$1);
  }
  if (tmp) {
    keyword = 'true';
    keywordUpper = 'TRUE';
    peeking = 5;
  } else {
    var tmp_2;
    var tmp_3 = tmp0_subject;
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
    if (tmp_3 === toByte(tmp$ret$2)) {
      tmp_2 = true;
    } else {
      var tmp_4 = tmp0_subject;
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(70);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      tmp_2 = tmp_4 === toByte(tmp$ret$3);
    }
    if (tmp_2) {
      keyword = 'false';
      keywordUpper = 'FALSE';
      peeking = 6;
    } else {
      var tmp_5;
      var tmp_6 = tmp0_subject;
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(110);
      var tmp$ret$4 = Char__toInt_impl_vasixd(this_4);
      if (tmp_6 === toByte(tmp$ret$4)) {
        tmp_5 = true;
      } else {
        var tmp_7 = tmp0_subject;
        // Inline function 'kotlin.code' call
        var this_5 = _Char___init__impl__6a9atx(78);
        var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
        tmp_5 = tmp_7 === toByte(tmp$ret$5);
      }
      if (tmp_5) {
        keyword = 'null';
        keywordUpper = 'NULL';
        peeking = 7;
      } else {
        return 0;
      }
    }
  }
  var length = keyword.length;
  var inductionVariable = 1;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!$this.i4a_1.t3x(add(numberToLong(i), 1n))) {
        return 0;
      }
      var c = $this.j4a_1.j3w(fromInt(i));
      var tmp_8;
      var tmp_9 = c;
      // Inline function 'kotlin.code' call
      var this_6 = charCodeAt(keyword, i);
      var tmp$ret$6 = Char__toInt_impl_vasixd(this_6);
      if (!(tmp_9 === toByte(tmp$ret$6))) {
        var tmp_10 = c;
        // Inline function 'kotlin.code' call
        var this_7 = charCodeAt(keywordUpper, i);
        var tmp$ret$7 = Char__toInt_impl_vasixd(this_7);
        tmp_8 = !(tmp_10 === toByte(tmp$ret$7));
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        return 0;
      }
    }
     while (inductionVariable < length);
  if ($this.i4a_1.t3x(add(numberToLong(length), 1n)) && isLiteral($this, numberToChar($this.j4a_1.j3w(fromInt(length))))) {
    return 0;
  }
  $this.j4a_1.x3u(fromInt(length));
  // Inline function 'kotlin.also' call
  var this_8 = peeking;
  $this.k4a_1 = this_8;
  return this_8;
}
function peekNumber($this) {
  var value = 0n;
  var negative = false;
  var fitsInLong = true;
  var last = 0;
  var i = 0;
  loop: while ($this.i4a_1.t3x(add(numberToLong(i), 1n))) {
    var c = $this.j4a_1.j3w(fromInt(i));
    var tmp0_subject = numberToChar(c);
    if (tmp0_subject === _Char___init__impl__6a9atx(45)) {
      switch (last) {
        case 0:
          negative = true;
          last = 1;
          break;
        case 5:
          last = 6;
          break;
        default:
          return 0;
      }
    } else if (tmp0_subject === _Char___init__impl__6a9atx(43)) {
      if (last === 5) {
        last = 6;
      } else {
        return 0;
      }
    } else if (tmp0_subject === _Char___init__impl__6a9atx(101) || tmp0_subject === _Char___init__impl__6a9atx(69)) {
      switch (last) {
        case 2:
        case 4:
          last = 5;
          break;
        default:
          return 0;
      }
    } else if (tmp0_subject === _Char___init__impl__6a9atx(46)) {
      if (last === 2) {
        last = 3;
      } else {
        return 0;
      }
    } else {
      var tmp;
      var tmp_0 = c;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      if (tmp_0 < toByte(tmp$ret$0)) {
        tmp = true;
      } else {
        var tmp_1 = c;
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(57);
        var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
        tmp = tmp_1 > toByte(tmp$ret$1);
      }
      if (tmp) {
        if (!isLiteral($this, numberToChar(c))) {
          break loop;
        } else {
          return 0;
        }
      }
      switch (last) {
        case 1:
        case 0:
          // Inline function 'kotlin.code' call

          var this_2 = _Char___init__impl__6a9atx(48);
          var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
          value = negate(fromInt(c - toByte(tmp$ret$2)));
          last = 2;
          break;
        case 2:
          if (value === 0n) {
            return 0;
          }

          // Inline function 'kotlin.Long.times' call

          var this_3 = value;
          var tmp0 = multiply(this_3, fromInt(10));
          // Inline function 'kotlin.code' call

          var this_4 = _Char___init__impl__6a9atx(48);
          var tmp$ret$4 = Char__toInt_impl_vasixd(this_4);
          // Inline function 'kotlin.Long.minus' call

          var other = c - toByte(tmp$ret$4);
          var newValue = subtract(tmp0, fromInt(other));
          fitsInLong = !!(fitsInLong & value > -922337203685477580n) || (value === -922337203685477580n && newValue < value);
          value = newValue;
          break;
        case 3:
          last = 4;
          break;
        case 5:
        case 6:
          last = 7;
          break;
      }
    }
    i = i + 1 | 0;
  }
  var tmp_2;
  if (last === 2 && fitsInLong && (!(value === -9223372036854775808n) || negative)) {
    $this.l4a_1 = negative ? value : negate(value);
    $this.j4a_1.x3u(fromInt(i));
    // Inline function 'kotlin.also' call
    $this.k4a_1 = 15;
    tmp_2 = 15;
  } else if (last === 2 || last === 4 || last === 7) {
    $this.m4a_1 = i;
    // Inline function 'kotlin.also' call
    $this.k4a_1 = 16;
    tmp_2 = 16;
  } else {
    tmp_2 = 0;
  }
  return tmp_2;
}
function isLiteral($this, c) {
  var tmp;
  if (c === _Char___init__impl__6a9atx(47) || c === _Char___init__impl__6a9atx(92) || (c === _Char___init__impl__6a9atx(59) || (c === _Char___init__impl__6a9atx(35) || c === _Char___init__impl__6a9atx(61)))) {
    throwSyntaxError($this, 'Unexpected character: ' + toString(c));
  } else if (c === _Char___init__impl__6a9atx(123) || c === _Char___init__impl__6a9atx(125) || (c === _Char___init__impl__6a9atx(91) || (c === _Char___init__impl__6a9atx(93) || c === _Char___init__impl__6a9atx(58))) || (c === _Char___init__impl__6a9atx(44) || c === _Char___init__impl__6a9atx(32) || (c === _Char___init__impl__6a9atx(9) || (c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(10))))) {
    tmp = false;
  } else {
    tmp = true;
  }
  return tmp;
}
function nextQuotedValue($this, runTerminator) {
  var builder = null;
  $l$loop: while (true) {
    var index = $this.i4a_1.t3y(runTerminator);
    if (index === -1n) {
      throwSyntaxError($this, 'Unterminated string');
    }
    var tmp = $this.j4a_1.j3w(index);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(92);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    if (tmp === toByte(tmp$ret$0)) {
      if (builder == null)
        builder = StringBuilder().l1();
      builder.m1($this.j4a_1.k3w(index));
      $this.j4a_1.w3x();
      builder.o1(readEscapeCharacter($this));
      continue $l$loop;
    }
    var tmp_0;
    if (builder == null) {
      var result = $this.j4a_1.k3w(index);
      $this.j4a_1.w3x();
      tmp_0 = result;
    } else {
      builder.m1($this.j4a_1.k3w(index));
      $this.j4a_1.w3x();
      tmp_0 = builder.toString();
    }
    return tmp_0;
  }
}
function nextUnquotedValue($this) {
  var i = $this.i4a_1.t3y(Companion_getInstance_0().x4a_1);
  return !(i === -1n) ? $this.j4a_1.k3w(i) : $this.j4a_1.c3y();
}
function skipQuotedValue($this, runTerminator) {
  while (true) {
    var index = $this.i4a_1.t3y(runTerminator);
    if (index === -1n) {
      throwSyntaxError($this, 'Unterminated string');
    }
    var tmp = $this.j4a_1.j3w(index);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(92);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    if (tmp === toByte(tmp$ret$0)) {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$1 = add(index, fromInt(1));
      $this.j4a_1.x3u(tmp$ret$1);
      readEscapeCharacter($this);
    } else {
      // Inline function 'kotlin.Long.plus' call
      var tmp$ret$2 = add(index, fromInt(1));
      $this.j4a_1.x3u(tmp$ret$2);
      return Unit_instance;
    }
  }
}
function skipUnquotedValue($this) {
  var i = $this.i4a_1.t3y(Companion_getInstance_0().x4a_1);
  $this.j4a_1.x3u(!(i === -1n) ? i : $this.j4a_1.w3u_1);
}
function push($this, newTop) {
  if ($this.p4a_1 === $this.o4a_1.length) {
    $this.o4a_1 = copyOf($this.o4a_1, imul($this.o4a_1.length, 2));
    $this.q4a_1 = copyOf_0($this.q4a_1, imul($this.q4a_1.length, 2));
    $this.r4a_1 = copyOf($this.r4a_1, imul($this.r4a_1.length, 2));
    $this.s4a_1 = copyOf($this.s4a_1, imul($this.s4a_1.length, 2));
  }
  var tmp = $this.o4a_1;
  var _unary__edvuaz = $this.p4a_1;
  $this.p4a_1 = _unary__edvuaz + 1 | 0;
  tmp[_unary__edvuaz] = newTop;
}
function nextNonWhitespace($this, throwOnEof) {
  var p = 0;
  loop: while ($this.i4a_1.t3x(add(numberToLong(p), 1n))) {
    var _unary__edvuaz = p;
    p = _unary__edvuaz + 1 | 0;
    var c = $this.j4a_1.j3w(fromInt(_unary__edvuaz));
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(10);
    if (c === Char__toInt_impl_vasixd(this_0)) {
      tmp_1 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(32);
      tmp_1 = c === Char__toInt_impl_vasixd(this_1);
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(13);
      tmp_0 = c === Char__toInt_impl_vasixd(this_2);
    }
    if (tmp_0) {
      tmp = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      tmp = c === Char__toInt_impl_vasixd(this_3);
    }
    if (tmp) {
      continue loop;
    }
    $this.j4a_1.x3u(subtract(numberToLong(p), 1n));
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(47);
    if (c === Char__toInt_impl_vasixd(this_4)) {
      if (!$this.i4a_1.t3x(2n)) {
        return c;
      }
      throwSyntaxError($this, 'Malformed JSON');
    } else {
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(35);
      if (c === Char__toInt_impl_vasixd(this_5)) {
        throwSyntaxError($this, 'Malformed JSON');
      } else {
        return c;
      }
    }
  }
  var tmp_2;
  if (throwOnEof) {
    throw EOFException().s3x('End of input');
  } else {
    tmp_2 = -1;
  }
  return tmp_2;
}
function getPathAsString($this) {
  return joinToString($this.d2s(), '.');
}
function readEscapeCharacter($this) {
  if (!$this.i4a_1.t3x(1n)) {
    throwSyntaxError($this, 'Unterminated escape sequence');
  }
  var escaped = numberToChar($this.j4a_1.w3x());
  var tmp;
  if (escaped === _Char___init__impl__6a9atx(117)) {
    if (!$this.i4a_1.t3x(4n)) {
      throw EOFException().s3x('Unterminated escape sequence at path ' + toString_0($this.d2s()));
    }
    var result = _Char___init__impl__6a9atx(0);
    var i = 0;
    var end = i + 4 | 0;
    while (i < end) {
      var c = $this.j4a_1.j3w(fromInt(i));
      // Inline function 'kotlin.code' call
      var this_0 = result;
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      result = numberToChar(tmp$ret$0 << 4);
      var tmp_0 = result;
      var tmp_1;
      var tmp_2;
      var tmp_3 = c;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(48);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      if (tmp_3 >= toByte(tmp$ret$1)) {
        var tmp_4 = c;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(57);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_2);
        tmp_2 = tmp_4 <= toByte(tmp$ret$2);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        // Inline function 'kotlin.code' call
        var this_3 = _Char___init__impl__6a9atx(48);
        var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
        tmp_1 = c - toByte(tmp$ret$3);
      } else {
        var tmp_5;
        var tmp_6 = c;
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(97);
        var tmp$ret$4 = Char__toInt_impl_vasixd(this_4);
        if (tmp_6 >= toByte(tmp$ret$4)) {
          var tmp_7 = c;
          // Inline function 'kotlin.code' call
          var this_5 = _Char___init__impl__6a9atx(102);
          var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
          tmp_5 = tmp_7 <= toByte(tmp$ret$5);
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          // Inline function 'kotlin.code' call
          var this_6 = _Char___init__impl__6a9atx(97);
          var tmp$ret$6 = Char__toInt_impl_vasixd(this_6);
          tmp_1 = c - toByte(tmp$ret$6) + 10 | 0;
        } else {
          var tmp_8;
          var tmp_9 = c;
          // Inline function 'kotlin.code' call
          var this_7 = _Char___init__impl__6a9atx(65);
          var tmp$ret$7 = Char__toInt_impl_vasixd(this_7);
          if (tmp_9 >= toByte(tmp$ret$7)) {
            var tmp_10 = c;
            // Inline function 'kotlin.code' call
            var this_8 = _Char___init__impl__6a9atx(70);
            var tmp$ret$8 = Char__toInt_impl_vasixd(this_8);
            tmp_8 = tmp_10 <= toByte(tmp$ret$8);
          } else {
            tmp_8 = false;
          }
          if (tmp_8) {
            // Inline function 'kotlin.code' call
            var this_9 = _Char___init__impl__6a9atx(65);
            var tmp$ret$9 = Char__toInt_impl_vasixd(this_9);
            tmp_1 = c - toByte(tmp$ret$9) + 10 | 0;
          } else {
            throwSyntaxError($this, '\\u' + $this.j4a_1.k3w(4n));
          }
        }
      }
      result = Char__plus_impl_qi7pgj(tmp_0, tmp_1);
      i = i + 1 | 0;
    }
    $this.j4a_1.x3u(4n);
    tmp = result;
  } else if (escaped === _Char___init__impl__6a9atx(116)) {
    tmp = _Char___init__impl__6a9atx(9);
  } else if (escaped === _Char___init__impl__6a9atx(98)) {
    tmp = _Char___init__impl__6a9atx(8);
  } else if (escaped === _Char___init__impl__6a9atx(110)) {
    tmp = _Char___init__impl__6a9atx(10);
  } else if (escaped === _Char___init__impl__6a9atx(114)) {
    tmp = _Char___init__impl__6a9atx(13);
  } else if (escaped === _Char___init__impl__6a9atx(102)) {
    tmp = _Char___init__impl__6a9atx(12);
  } else if (escaped === _Char___init__impl__6a9atx(10) || escaped === _Char___init__impl__6a9atx(39) || (escaped === _Char___init__impl__6a9atx(34) || (escaped === _Char___init__impl__6a9atx(92) || escaped === _Char___init__impl__6a9atx(47)))) {
    tmp = escaped;
  } else {
    throwSyntaxError($this, 'Invalid escape sequence: \\' + toString(escaped));
  }
  return tmp;
}
function throwSyntaxError($this, message) {
  throw JsonEncodingException().d4c(message + ' at path ' + toString_0($this.d2s()));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u4a_1 = -922337203685477580n;
        this.v4a_1 = Companion_getInstance().s3w("'\\");
        this.w4a_1 = Companion_getInstance().s3w('"\\');
        this.x4a_1 = Companion_getInstance().s3w('{}[]:, \n\t\r/\\;#=');
        this.y4a_1 = 0;
        this.z4a_1 = 1;
        this.a4b_1 = 2;
        this.b4b_1 = 3;
        this.c4b_1 = 4;
        this.d4b_1 = 5;
        this.e4b_1 = 6;
        this.f4b_1 = 7;
        this.g4b_1 = 8;
        this.h4b_1 = 9;
        this.i4b_1 = 10;
        this.j4b_1 = 11;
        this.k4b_1 = 12;
        this.l4b_1 = 13;
        this.m4b_1 = 14;
        this.n4b_1 = 15;
        this.o4b_1 = 16;
        this.p4b_1 = 17;
        this.q4b_1 = 0;
        this.r4b_1 = 1;
        this.s4b_1 = 2;
        this.t4b_1 = 3;
        this.u4b_1 = 4;
        this.v4b_1 = 5;
        this.w4b_1 = 6;
        this.x4b_1 = 7;
        this.y4b_1 = 64;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var BufferedSourceJsonReaderClass;
function BufferedSourceJsonReader() {
  if (BufferedSourceJsonReaderClass === VOID) {
    class $ {
      constructor(source) {
        Companion_getInstance_0();
        this.i4a_1 = source;
        this.j4a_1 = this.i4a_1.m3x();
        this.k4a_1 = 0;
        this.l4a_1 = 0n;
        this.m4a_1 = 0;
        this.n4a_1 = null;
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new Int32Array(64);
        this_0[0] = 6;
        tmp.o4a_1 = this_0;
        this.p4a_1 = 1;
        var tmp_0 = this;
        // Inline function 'kotlin.arrayOfNulls' call
        tmp_0.q4a_1 = Array(64);
        this.r4a_1 = new Int32Array(64);
        var tmp_1 = this;
        // Inline function 'kotlin.apply' call
        var this_1 = new Int32Array(64);
        this_1[0] = 0;
        tmp_1.s4a_1 = this_1;
        this.t4a_1 = 1;
      }
      t40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 3) {
          push(this, 1);
          this.r4a_1[this.p4a_1 - 1 | 0] = 0;
          this.k4a_1 = 0;
        } else {
          throw JsonDataException().w46('Expected BEGIN_ARRAY but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return this;
      }
      u40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 4) {
          this.p4a_1 = this.p4a_1 - 1 | 0;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          this.k4a_1 = 0;
        } else {
          throw JsonDataException().w46('Expected END_ARRAY but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return this;
      }
      o40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 1) {
          push(this, 3);
          this.k4a_1 = 0;
          this.t4a_1 = this.t4a_1 + 1 | 0;
          this.s4a_1[this.t4a_1 - 1 | 0] = 0;
        } else {
          throw JsonDataException().w46('Expected BEGIN_OBJECT but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return this;
      }
      p40() {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 2) {
          this.p4a_1 = this.p4a_1 - 1 | 0;
          this.q4a_1[this.p4a_1] = null;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          this.k4a_1 = 0;
          this.t4a_1 = this.t4a_1 - 1 | 0;
        } else {
          throw JsonDataException().w46('Expected END_OBJECT but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return this;
      }
      q1() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        return !(p === 2) && !(p === 4);
      }
      r3z() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        switch (tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) {
          case 1:
            tmp_0 = Token_BEGIN_OBJECT_getInstance();
            break;
          case 2:
            tmp_0 = Token_END_OBJECT_getInstance();
            break;
          case 3:
            tmp_0 = Token_BEGIN_ARRAY_getInstance();
            break;
          case 4:
            tmp_0 = Token_END_ARRAY_getInstance();
            break;
          case 12:
          case 13:
          case 14:
            tmp_0 = Token_NAME_getInstance();
            break;
          case 5:
          case 6:
            tmp_0 = Token_BOOLEAN_getInstance();
            break;
          case 7:
            tmp_0 = Token_NULL_getInstance();
            break;
          case 8:
          case 9:
          case 10:
          case 11:
            tmp_0 = Token_STRING_getInstance();
            break;
          case 15:
            tmp_0 = Token_LONG_getInstance();
            break;
          case 16:
            tmp_0 = Token_NUMBER_getInstance();
            break;
          case 17:
            tmp_0 = Token_END_DOCUMENT_getInstance();
            break;
          default:
            throw AssertionError().qe();
        }
        return tmp_0;
      }
      q40() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        switch (tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) {
          case 14:
            tmp_0 = nextUnquotedValue(this);
            break;
          case 13:
            tmp_0 = nextQuotedValue(this, Companion_getInstance_0().w4a_1);
            break;
          case 12:
            tmp_0 = nextQuotedValue(this, Companion_getInstance_0().v4a_1);
            break;
          default:
            throw JsonDataException().w46('Expected a name but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        var result = tmp_0;
        this.k4a_1 = 0;
        this.q4a_1[this.p4a_1 - 1 | 0] = result;
        return result;
      }
      y40() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        switch (tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) {
          case 10:
            tmp_0 = nextUnquotedValue(this);
            break;
          case 9:
            tmp_0 = nextQuotedValue(this, Companion_getInstance_0().w4a_1);
            break;
          case 8:
            tmp_0 = nextQuotedValue(this, Companion_getInstance_0().v4a_1);
            break;
          case 11:
            var tmp2_safe_receiver = this.n4a_1;
            var tmp_1;
            if (tmp2_safe_receiver == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.also' call
              this.n4a_1 = null;
              tmp_1 = tmp2_safe_receiver;
            }

            tmp_0 = tmp_1;
            break;
          case 15:
            tmp_0 = this.l4a_1.toString();
            break;
          case 16:
            tmp_0 = this.j4a_1.k3w(fromInt(this.m4a_1));
            break;
          default:
            throw JsonDataException().w46('Expected a string but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        var result = tmp_0;
        this.k4a_1 = 0;
        var _array__4zh2yp = this.r4a_1;
        var _index_0__fvwizt = this.p4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        return result;
      }
      zn() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        switch (tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) {
          case 5:
            this.k4a_1 = 0;
            var _array__4zh2yp = this.r4a_1;
            var _index_0__fvwizt = this.p4a_1 - 1 | 0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
            tmp_0 = true;
            break;
          case 6:
            this.k4a_1 = 0;
            var _array__4zh2yp_0 = this.r4a_1;
            var _index_0__fvwizt_0 = this.p4a_1 - 1 | 0;
            _array__4zh2yp_0[_index_0__fvwizt_0] = _array__4zh2yp_0[_index_0__fvwizt_0] + 1 | 0;
            tmp_0 = false;
            break;
          default:
            throw JsonDataException().w46('Expected a boolean but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return tmp_0;
      }
      k49() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if ((tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) === 7) {
          this.k4a_1 = 0;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          tmp_0 = null;
        } else {
          throw JsonDataException().w46('Expected null but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        return tmp_0;
      }
      d41() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 15) {
          this.k4a_1 = 0;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          return toNumber(this.l4a_1);
        } else if (p === 16) {
          this.n4a_1 = this.j4a_1.k3w(fromInt(this.m4a_1));
        } else if (p === 9) {
          this.n4a_1 = nextQuotedValue(this, Companion_getInstance_0().w4a_1);
        } else if (p === 8) {
          this.n4a_1 = nextQuotedValue(this, Companion_getInstance_0().v4a_1);
        } else if (p === 10) {
          this.n4a_1 = nextUnquotedValue(this);
        } else if (!(p === 11))
          throw JsonDataException().w46('Expected a double but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        this.k4a_1 = 11;
        var tmp_0;
        try {
          tmp_0 = toDouble(ensureNotNull(this.n4a_1));
        } catch ($p) {
          var tmp_1;
          if ($p instanceof NumberFormatException()) {
            var e = $p;
            throw JsonDataException().w46('Expected a double but was ' + this.n4a_1 + ' at path ' + getPathAsString(this));
          } else {
            throw $p;
          }
        }
        var result = tmp_0;
        if (isNaN_0(result) || isInfinite(result)) {
          throw JsonEncodingException().d4c('JSON forbids NaN and infinities: ' + result + ' at path ' + getPathAsString(this));
        }
        this.n4a_1 = null;
        this.k4a_1 = 0;
        var _array__4zh2yp_0 = this.r4a_1;
        var _index_0__fvwizt_0 = this.p4a_1 - 1 | 0;
        _array__4zh2yp_0[_index_0__fvwizt_0] = _array__4zh2yp_0[_index_0__fvwizt_0] + 1 | 0;
        return result;
      }
      wn() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 15) {
          this.k4a_1 = 0;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          return this.l4a_1;
        } else if (p === 16) {
          this.n4a_1 = this.j4a_1.k3w(fromInt(this.m4a_1));
        } else if (p === 9 || p === 8) {
          this.n4a_1 = p === 9 ? nextQuotedValue(this, Companion_getInstance_0().w4a_1) : nextQuotedValue(this, Companion_getInstance_0().v4a_1);
          try {
            var result = toLong(ensureNotNull(this.n4a_1));
            this.k4a_1 = 0;
            var _array__4zh2yp_0 = this.r4a_1;
            var _index_0__fvwizt_0 = this.p4a_1 - 1 | 0;
            _array__4zh2yp_0[_index_0__fvwizt_0] = _array__4zh2yp_0[_index_0__fvwizt_0] + 1 | 0;
            return result;
          } catch ($p) {
            if ($p instanceof NumberFormatException()) {
              var ignored = $p;
            } else {
              throw $p;
            }
          }
        } else if (!(p === 11))
          throw JsonDataException().w46('Expected a long but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        this.k4a_1 = 11;
        var tmp_0;
        try {
          tmp_0 = toDouble(ensureNotNull(this.n4a_1));
        } catch ($p) {
          var tmp_1;
          if ($p instanceof NumberFormatException()) {
            var e = $p;
            throw JsonDataException().w46('Expected a long but was ' + this.n4a_1 + ' at path ' + getPathAsString(this));
          } else {
            throw $p;
          }
        }
        var asDouble = tmp_0;
        var result_0 = numberToLong(asDouble);
        if (!(toNumber(result_0) === asDouble)) {
          throw JsonDataException().w46('Expected a long but was ' + this.n4a_1 + ' at path ' + getPathAsString(this));
        }
        this.n4a_1 = null;
        this.k4a_1 = 0;
        var _array__4zh2yp_1 = this.r4a_1;
        var _index_0__fvwizt_1 = this.p4a_1 - 1 | 0;
        _array__4zh2yp_1[_index_0__fvwizt_1] = _array__4zh2yp_1[_index_0__fvwizt_1] + 1 | 0;
        return result_0;
      }
      e4c() {
        return new (JsonNumber())(ensureNotNull(this.y40()));
      }
      kk() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.k4a_1;
        var tmp;
        if (!(this_0 === 0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var p = tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs;
        if (p === 15) {
          var result = convertToInt(this.l4a_1);
          if (!(this.l4a_1 === fromInt(result))) {
            throw JsonDataException().w46('Expected an int but was ' + this.l4a_1 + ' at path ' + toString_0(this.d2s()));
          }
          this.k4a_1 = 0;
          var _array__4zh2yp = this.r4a_1;
          var _index_0__fvwizt = this.p4a_1 - 1 | 0;
          _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
          return result;
        } else if (p === 16) {
          this.n4a_1 = this.j4a_1.k3w(fromInt(this.m4a_1));
        } else if (p === 9 || p === 8) {
          this.n4a_1 = p === 9 ? nextQuotedValue(this, Companion_getInstance_0().w4a_1) : nextQuotedValue(this, Companion_getInstance_0().v4a_1);
          try {
            var result_0 = toInt(ensureNotNull(this.n4a_1));
            this.k4a_1 = 0;
            var _array__4zh2yp_0 = this.r4a_1;
            var _index_0__fvwizt_0 = this.p4a_1 - 1 | 0;
            _array__4zh2yp_0[_index_0__fvwizt_0] = _array__4zh2yp_0[_index_0__fvwizt_0] + 1 | 0;
            return result_0;
          } catch ($p) {
            if ($p instanceof NumberFormatException()) {
              var ignored = $p;
            } else {
              throw $p;
            }
          }
        } else if (!(p === 11)) {
          throw JsonDataException().w46('Expected an int but was ' + this.r3z().toString() + ' at path ' + getPathAsString(this));
        }
        this.k4a_1 = 11;
        var tmp_0;
        try {
          tmp_0 = toDouble(ensureNotNull(this.n4a_1));
        } catch ($p) {
          var tmp_1;
          if ($p instanceof NumberFormatException()) {
            var e = $p;
            throw JsonDataException().w46('Expected an int but was ' + this.n4a_1 + ' at path ' + getPathAsString(this));
          } else {
            throw $p;
          }
        }
        var asDouble = tmp_0;
        var result_1 = numberToInt(asDouble);
        if (!(result_1 === asDouble)) {
          throw JsonDataException().w46('Expected an int but was ' + this.n4a_1 + ' at path ' + getPathAsString(this));
        }
        this.n4a_1 = null;
        this.k4a_1 = 0;
        var _array__4zh2yp_1 = this.r4a_1;
        var _index_0__fvwizt_1 = this.p4a_1 - 1 | 0;
        _array__4zh2yp_1[_index_0__fvwizt_1] = _array__4zh2yp_1[_index_0__fvwizt_1] + 1 | 0;
        return result_1;
      }
      l6() {
        this.k4a_1 = 0;
        this.o4a_1[0] = 8;
        this.p4a_1 = 1;
        this.j4a_1.a5();
        this.i4a_1.l6();
      }
      q3z() {
        var count = 0;
        do {
          // Inline function 'kotlin.takeUnless' call
          var this_0 = this.k4a_1;
          var tmp;
          if (!(this_0 === 0)) {
            tmp = this_0;
          } else {
            tmp = null;
          }
          var tmp0_elvis_lhs = tmp;
          switch (tmp0_elvis_lhs == null ? doPeek(this) : tmp0_elvis_lhs) {
            case 3:
              push(this, 1);
              count = count + 1 | 0;
              break;
            case 1:
              push(this, 3);
              count = count + 1 | 0;
              break;
            case 4:
              this.p4a_1 = this.p4a_1 - 1 | 0;
              count = count - 1 | 0;
              break;
            case 2:
              this.p4a_1 = this.p4a_1 - 1 | 0;
              count = count - 1 | 0;
              break;
            case 14:
            case 10:
              skipUnquotedValue(this);
              break;
            case 9:
            case 13:
              skipQuotedValue(this, Companion_getInstance_0().w4a_1);
              break;
            case 8:
            case 12:
              skipQuotedValue(this, Companion_getInstance_0().v4a_1);
              break;
            case 16:
              this.j4a_1.x3u(fromInt(this.m4a_1));
              break;
          }
          this.k4a_1 = 0;
        }
         while (!(count === 0));
        var _array__4zh2yp = this.r4a_1;
        var _index_0__fvwizt = this.p4a_1 - 1 | 0;
        _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] + 1 | 0;
        this.q4a_1[this.p4a_1 - 1 | 0] = 'null';
      }
      f4c(names) {
        if (names.n1()) {
          return -1;
        }
        while (this.q1()) {
          var name = this.q40();
          var expectedIndex = this.s4a_1[this.t4a_1 - 1 | 0];
          if (names.r2(expectedIndex) === name) {
            // Inline function 'kotlin.also' call
            this.s4a_1[this.t4a_1 - 1 | 0] = expectedIndex + 1 | 0;
            if (this.s4a_1[this.t4a_1 - 1 | 0] === names.q2()) {
              this.s4a_1[this.t4a_1 - 1 | 0] = 0;
            }
            return expectedIndex;
          } else {
            var index = expectedIndex;
            $l$loop: while (true) {
              index = index + 1 | 0;
              if (index === names.q2()) {
                index = 0;
              }
              if (index === expectedIndex) {
                break $l$loop;
              }
              if (names.r2(index) === name) {
                // Inline function 'kotlin.also' call
                var this_0 = index;
                this.s4a_1[this.t4a_1 - 1 | 0] = index + 1 | 0;
                if (this.s4a_1[this.t4a_1 - 1 | 0] === names.q2()) {
                  this.s4a_1[this.t4a_1 - 1 | 0] = 0;
                }
                return this_0;
              }
            }
            this.q3z();
          }
        }
        return -1;
      }
      d2s() {
        return JsonScope_instance.e4a(this.p4a_1, this.o4a_1, this.q4a_1, this.r4a_1);
      }
      g4c() {
        // Inline function 'kotlin.error' call
        var message = 'BufferedSourceJsonReader cannot rewind.';
        throw IllegalStateException().o(toString_0(message));
      }
    }
    initMetadataForClass($, 'BufferedSourceJsonReader');
    BufferedSourceJsonReaderClass = $;
  }
  return BufferedSourceJsonReaderClass;
}
//region block: exports
export {
  BufferedSourceJsonReader as BufferedSourceJsonReader1eguw7qhrwt7p,
};
//endregion

//# sourceMappingURL=BufferedSourceJsonReader.mjs.map
